
import React, { useEffect, useState } from "react";
import { isEmpty, isEqual } from "lodash";
import FiltersBar from "components/FiltersBar";
import { hasMetricValue } from "utils/communities";

const CHBAResultsFilters = React.memo(({
    allModels,
    setFilteredModels,
    locationOpts,
    userOpts,
    modelOpts,
    graphMetric,
    setPage,
}) => {
    // Flag to determine if filters were updated
    const [newFilter, setNewFilter] = useState(false);
    const [initialFilters, setInitialFilters] = useState({});

    // List of selected filters
    const [selectedLocs, setSelectedLocs] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedModels, setSelectedModels] = useState([]);

    // Clear filters
    const handleClear = () => {
        const unFilteredData = allModels.filter((model) => hasMetricValue(model, graphMetric));

        // Select all filter options
        setSelectedLocs(initialFilters.locations);
        setSelectedUsers(initialFilters.users);
        setSelectedModels(initialFilters.models);

        // Reset filtered models list and disable apply button
        setFilteredModels(unFilteredData);
        setNewFilter(false);
        setPage(0);
    };

    // Apply filters
    const handleApply = () => {
        const filteredData = allModels.filter((model) => {
            const selectedUserNames = userOpts.filter((opt) => selectedUsers.includes(opt.value)).map((opt) => opt.label);
            const matchLocation = selectedLocs.includes(model.provTerr);
            const matchUser = selectedUserNames.includes(model.userName);
            const matchModel = selectedModels.includes(model.key);

            return matchLocation && matchUser && matchModel && hasMetricValue(model, graphMetric);
        });

        // Update filtered models list and disable button after applying
        setFilteredModels(filteredData);
        setNewFilter(false);
        setPage(0);
    };

    // Update selected filter lists
    const handleChange = (type, value) => {
        if (type === "location")
            setSelectedLocs(value);
        else if (type === "user")
            setSelectedUsers(value);
        else if (type === "model")
            setSelectedModels(value);

        setNewFilter(true);
    }

    useEffect(() => {
        const initLocations = locationOpts.map((opt) => opt.value);
        const initUsers = userOpts.map((opt) => opt.value);
        const initModels = modelOpts.map((opt) => opt.value);

        setInitialFilters({
            locations: initLocations,
            users: initUsers,
            models: initModels,
        });

        setSelectedLocs(initLocations);
        setSelectedUsers(initUsers);
        setSelectedModels(initModels);
    }, [locationOpts, userOpts, modelOpts]);

    // Reapply filters when graph metric is updated to exclude models missing results for that metric
    useEffect(() => {
        handleApply();
    }, [graphMetric]);

    return (
        <FiltersBar
            multiSelectInputs={[
                {
                    label: "Location",
                    options: locationOpts,
                    selectedOpts: selectedLocs,
                    handleOptChange: (value) => handleChange("location", value),
                },
                {
                    label: "User",
                    options: userOpts,
                    selectedOpts: selectedUsers,
                    handleOptChange: (value) => handleChange("user", value),
                },
                {
                    label: "Models",
                    options: modelOpts,
                    selectedOpts: selectedModels,
                    handleOptChange: (value) => handleChange("model", value),
                }
            ]}
            handleApply={handleApply}
            handleClear={handleClear}
            newFilter={newFilter}
        />
    );
}, isEqual);

export default CHBAResultsFilters;